import { __assign } from "tslib";
import React from 'react';
import { Box } from '../../Box';
export var InlineDropdown = function (props) {
    var isOpen = props.isOpen, BoxProps = props.BoxProps, children = props.children;
    if (!isOpen) {
        return null;
    }
    return React.createElement(Box, __assign({}, BoxProps), children);
};
//# sourceMappingURL=ListboxDropdown.InlineDropdown.js.map